<template>
    <section
        class="popup fixed top-0 left-0 w-full h-full py-20 z-2000 overflow-y-auto transition-all !duration-800"
        :class="{'!opacity-0 !pointer-events-none' : !showPopup}"
        style="background-color:rgba(13, 13, 13, .82)"
    >

        <div class="w-full max-w-[calc(100%-3rem)] sm:max-w-xl md:max-w-xl lg:max-w-3xl xl:max-w-4xl mx-auto p-10 md:p-14 xl:p-16 2.5xl:py-20 bg-[#1a1a1a] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">

            <button @click="closePopup" class="absolute popup-close top-6 right-6 md:top-8 md:right-8" type="button">
                <img class="w-[20px] h-[20px]" alt="icona" width="40" height="40" src="/images/svg/close.svg"/>
            </button>

            <h2 class="text-white text-[40px] sm:text-[45px] md:text-[50px] lg:text-[54px] xl:text-[60px] 2xl:text-[64px] 3xl:text-[67px] 3.5xl:text-[70px] !leading-snug tracking-[0.01em] mx-auto text-center mb-6 mt-8 md:mt-4">
                {{$root.translateString('enter-the-wine-club')}}
            </h2>

            <div class="relative w-full mb-10 text-center xl:mb-14">
                <p class="text-white text-lg xl:text-xl 2.5xl:text-1.5xl !leading-snug">
                    {{$root.translateString('enter-the-wine-club-text')}}
                </p>
            </div>

            <div class="flex flex-col items-center w-full mb-5 space-y-5 text-center md:mb-0">
                <a :href="linkRegister" class="relative inline-flex transition-all border default-btn border-primary-300 group hover:bg-primary-400/10">
                    <span class="block pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                        {{$root.translateString('register-now')}}
                    </span>
                    <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                    <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                </a>
                <a :href="linkLogin" class="text-[18px] md:text-[19px] xl:text-[20px] underline transition-all text-white/50 hover:text-white/100">
                    {{$root.translateString('have-an-account')}}
                </a>
            </div>

        </div>

    </section>
</template>

<script>
    export default {

        props: ['linkRegister', 'linkLogin'],

        data() {
            return {
                showPopup: false,
            }
        },

        methods: {

            setCookie(key, value, expiry) {
                let expires = new Date();
                expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
            },

            getCookie(key) {
                let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            },

            closePopup() {
                document.querySelector('body').classList.remove('overflow-hidden')
                this.showPopup = false
            }

        },

        mounted() {

            // Mostra solo dopo che l'utente ha chiuso il popup 50 anni (cookie 'popup50AnniDismissed').
            // Cosi non si sovrappone agli altri popup sulla home: appare su una navigazione/refresh successivo.
            if(this.getCookie('wineClubPopup') == null && this.getCookie('popup50AnniDismissed') != null) {
                setTimeout(() => {
                    document.querySelector('body').classList.add('overflow-hidden')
                    this.showPopup = true
                    this.setCookie('wineClubPopup', '1', '1');
                }, 4000)
            }

        }

    }
</script>

<style lang="scss" scoped>

</style>
